import Vue from 'vue';
import template from '!!raw-loader!./template.html';
import single from '@/common/singleFormCreate.js';
import { groupConvert } from 'skytech-vue2-form-core';

const { render } = Vue.compile(template);
import groupNavPanel from '@/components/iglobalwin/groupNavPanel/groupNavPanel.vue';

export default function ({
	className,
	getFormData,
	load,
	submit,
	cancel,
	submitSucess,
	// submitValidateFail,
	data,
	showNavPanel,
	labelWidth,
	labelLeft,
	multiGroupConfig,
	titleTooltip, // 是否显示头部信息
	titleTooltipInfo, // 头部信息
	otherBtn, // 其他按钮
	otherBtnText, // 其他按钮文案
}) {
	const formPage = single({
		getFormData: groupConvert(getFormData, true, {}, multiGroupConfig),
		load,
		async submit(data) {
			this.errorMsgList = [];
			try {
				await submit.call(this, data);
			} catch (err) {
				this.formData.loading = false;
			}
		},
		submitSucess,
		submitValidateFail(msg) {
			this.errorMsgList = msg;

			this.$message.error('请完善表单');
			this.formData.loading = false;
		},
		mixins: [
			{
				// beforeRouteLeave (to, from, next) {
				// 	if(!to.fullPath.includes('accountManagement')) {
				// 		setTimeout(() => {
				// 			this.$confirm('离开本页面当前数据不保存？', '提示', {
				// 				confirmButtonText: '是',
				// 				cancelButtonText: '否'
				// 			})
				// 				.then(() => {
				// 					next()
				// 				})
				// 				.catch(() => {
				// 					next(false)
				// 				})
				// 		}, 200)
				// 	}else {
				// 		next()
				// 	}
				// },
				computed: {
					groupsForm() {
						let res = _.groupBy(this.formData.fields, item => {
							return item.group.title;
						});
						return res;
					},
					getTitleTooltip() {
						let res = titleTooltipInfo.call(this);
						return res;
					},
				},
				data() {
					return {
						...data,
						showNavPanel: showNavPanel,
						labelLeft: labelLeft || 'left',
						className: className,
						labelWidth: labelWidth,
						titleTooltip: titleTooltip || false,
						errorMsgList: [], // 错误信息列表
						otherBtn: otherBtn || false,
						otherIsTrue: false,
						otherBtnText: otherBtnText || '保存并继续新建广告',
					};
				},
				methods: {
					onCancel() {
						cancel(this);
						this.errorMsgList = [];
					},
				},
			},
		],
	});
	if (showNavPanel) {
		formPage.components = {
			groupNavPanel,
		};
	}
	formPage.render = render;
	return formPage;
}
